export default __webpack_public_path__ + "static/icon-28-1-1b14be3d422677ed4d288e30db8b30b6.png";